import { connect } from 'react-redux';

import { ErrorActions, ErrorSelectors } from '@zapier/toolbox-redux-framework';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as CliAppEventStats from 'app/entities/CliAppEventStats';
import * as CliAppEvents from 'app/entities/CliAppEvents';
import * as Profile from 'app/entities/Profile';
import { currentAppVersion } from 'app/developer-v3/selectors';
import { selectAppId } from 'app/developer-v3/store/selectors';
import MaybeLoad from 'app/common/components/MaybeLoad';
import hocify from 'app/common/components/hocify';
import { trackEvent } from 'app/developer-v3/Actions';

import MonitoringPage from './MonitoringPage';

const mapStateToProps = state => {
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const appId = selectAppId(state);
  const appVersion = currentAppVersion(state);

  return {
    appId,
    appVersion,
    appEvents: CliAppEvents.selectors.all.dataItem('events', state),
    appEventStats: CliAppEventStats.selectors.all.data(state),
    errors: ErrorSelectors.getErrors(state),
    hasAcceptedTerms: !!Profile.selectors.hasAcceptedTerms(currentProfile),
    isLoading:
      CliApp.selectors.all.isLoadingById(appId, state) ||
      CliAppDefinition.selectors.all.isLoadingById(appId, state) ||
      CliAppEventStats.selectors.all.isLoadImpending(state),
    isStaff: Profile.selectors.isStaff(currentProfile),
    loadingStates: {
      appEvents: CliAppEvents.selectors.all.isLoading(state),
      appEventStats: CliAppEventStats.selectors.all.isLoadImpending(state),
    },
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    async onLoad() {
      await Promise.all([
        dispatch(CliAppEvents.actions.resetCollection()),
        dispatch(CliAppEventStats.actions.resetCollection()),
        dispatch(
          trackEvent('Dev Platform Event: Stats', {
            event: 'Fetching initial data',
            eventData: { appId: props.params.id },
          })
        ),
        dispatch(
          CliAppEventStats.actions.loadCollectionWithParams({
            appVersion: props.appSummary.version,
            period: '1h',
          })
        ),
      ]);
    },
    clearAppEvents() {
      dispatch(CliAppEvents.actions.resetCollection());
    },
    clearErrors() {
      dispatch(ErrorActions.clearErrors());
    },
    loadAppEvents(filters) {
      dispatch(
        CliAppEvents.actions.loadCollectionWithParams({
          start_date: new Date().toISOString(),
          end_date: new Date().toISOString(),
          personal: false,
          category: 'all',
          ...filters,
        })
      );
    },
    loadAppEventStats(filters) {
      const eventFilters = { period: '1h', ...filters };
      dispatch(CliAppEventStats.actions.loadCollectionWithParams(eventFilters));
    },
    async trackPageEvent(trackData) {
      await dispatch(trackEvent('Dev Platform Event: Stats', trackData));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(MaybeLoad)(MonitoringPage));
